import { produce } from 'immer'
import { State } from '../typings'

export type UnmatchServiceAction = {
  type: 'unmatchService'
  payload: number | number[]
}

export const unmatchService = produce<State, [UnmatchServiceAction['payload']]>(
  (draft, payload) => {
    const toRemove = Array.isArray(payload) ? payload : [payload]
    toRemove.map((id) => draft.matches.delete(id))
  },
)
